<template>
  <div style="width:100%">
    <v-row class="inventory-container">
      <v-col cols="12">
        <VAutocomplete
          v-model="selectedProducts"
          :items="productList"
          :menuProps="{ maxHeight: '400' }"
          :label="$t('forms.labels.alertInventory')"
          chips
          clearable
          outlined
          multiple
          :readonly="readOnly"
          :searchInput.sync="search"
        />
      </v-col>
    </v-row>
    <div style="width:100%">
      <VTableLocal
        v-if="selectedProducts.length > 0"
        :items="productsInventoryObj"
        :headers="headers"
        disablePagination
      >
        <template #item.product="{ item }">
          <div>{{ item.productName }}</div>
        </template>
        <template #item.location="{ item }">
          <div>{{ item.location }}</div>
        </template>
        <template #item.container="{ item }">
          <div>{{ item.container }}</div>
        </template>
        <template #item.quantityMin="{ item }">
          <VTextField
            :value="item.alertQuantityMin"
            :readonly="readOnly"
            outlined
            @input="(newVal)=>onMinQtyChange(newVal,item.id)"
          />
        </template>
      </VTableLocal>
    </div>
  </div>
</template>
<script>
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField';
import VAutocomplete from '@/components/shared/widgets/forms/VuetifyInputs/VAutocomplete.vue';
import VTableLocal from '@/components/shared/content-views/VTableLocal';


export default {
    components: { VTextField, VAutocomplete, VTableLocal },
    props: {
        inventoryProductList: {
            type: Array,
            default: () => [],
        },
        inventoryVals: {
            type: Object,
            default: () => {},
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            selectedProducts: [],
            productsInventoryObj: {},
            search: '',
            headers: [{ text: this.$t('forms.labels.product'), value: 'product' }, { text: this.$t('forms.labels.location'), value: 'location' }, { text: this.$t('forms.labels.container'), value: 'container' }, { text: this.$t('forms.labels.quantityMin'), value: 'quantityMin' }],
        };
    },
    computed: {
        productList() {
            return this.inventoryProductList.map(inv => ({
                id: inv.id,
                name: `${inv.product.name},${inv.location},${inv.container}`,
                value: inv,
                disabled: false,
                divider: false,
            }));
        },
    },
    watch: {
        selectedProducts: {
            handler() {
                this.search = '';
                this.importProduct();

                this.onInventoryObjChange();
            },
            immediate: true,
        },
    },
    created() {
        if (this.inventoryVals.initValue) {
            const foundArr = [];
            this.inventoryVals.initValue.forEach(inv => {
                const found = {
                    ...inv,
                    product: { name: inv.productName },
                    quantityMin: inv.alertQuantityMin,
                };
                foundArr.push(found);
            });
            this.selectedProducts = foundArr.map(sp => sp.id);
            this.productsInventoryObj = foundArr;
        }
    },

    mounted() {
        this.inventoryVals.initValue.forEach(item => {
            // Récupérer l'ID de l'élément correspondant dans inventoryVals
            const itemId = item.id;

            // Vérifier si l'élément correspondant existe dans inventoryVals
            if (this.inventoryVals[itemId]) {
                // Remplacer la valeur de quantityMin par la valeur de alertQuantityMin
                this.inventoryVals[itemId].value.quantityMin = item.alertQuantityMin;
            }
        });
    },

    methods: {
        onInventoryObjChange() {
            this.$emit('inventoryProductsChange', this.productsInventoryObj);
        },
        onMinQtyChange(newVal, invId) {
            const data = this.productsInventoryObj.find(pi => pi.id === invId);
            data.alertQuantityMin = newVal;
            this.onInventoryObjChange(data);
        },
        onInventoryRemove(index) {
            this.selectedProducts.splice(index, 1);
        },
        importProduct() {
            if (this.selectedProducts.length) {
                const filteredProducts = this.productsInventoryObj.filter(product => this.selectedProducts.includes(product.id));
                this.productsInventoryObj = filteredProducts;
                if (this.productsInventoryObj.length < this.selectedProducts.length) {
                    const idItemAdded = this.selectedProducts[this.selectedProducts.length - 1];
                    const wholeItem = this.productList.find(elt => elt.id === idItemAdded);
                    const wholeItemReformated = {
                        productName: wholeItem.value.product.name,
                        id: wholeItem.id,
                        container: wholeItem.value.container,
                        location: wholeItem.value.location,
                        alertQuantityMin: wholeItem.value.quantityMin,
                        product: {
                            name: wholeItem.value.product.name,
                            id: wholeItem.value.product.id,
                        },
                        quantityMin: wholeItem.value.quantityMin,
                    };
                    this.productsInventoryObj.push(wholeItemReformated);
                }
            }
        },
    },
};
</script>
<style scoped>
.user-remove{
      background-color: #26384a;
      padding: 5px;
      border-radius: 50%;
    }
    .user-remove i{
      color: white;
    }
</style>
